import { createSlice } from "@reduxjs/toolkit";

export const sidebarSlice = createSlice({
	name: "sidebar",
	initialState: {
		showSidebar: false,
	},
	reducers: {
		handleShowSidebar: state => ({
			...state,
			showSidebar: true,
		}),
		handleCloseSidebar: state => ({
			...state,
			showSidebar: false,
		}),
	},
});
export const { handleShowSidebar, handleCloseSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;
